import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { retry, catchError } from "rxjs/operators";
import { TipoPersona } from "../model/tipopersona";
import { Provincia } from "../model/provincia";
import { Municipio } from "../model/municipio";
import { Documento } from "../model/documento";
import { Via } from "../model/via";
import { Pais } from "../model/pais";
import { FAQ } from "../model/FAQ";

import { formatDate } from "@angular/common";
import { environment } from "src/environments/environment";
import { RolUsuario } from "../model/rolusuario";

import { TokenStorageService } from "./token-storage.service";
import { Procedimiento } from "../model/procedimiento";
import { UsuarioRecuperar } from "../model/usuariorecuperar";
import { EstadoCivil } from "../model/estadocivil";
import { GradoDiscapacidad } from "../model/gradodiscapacidad";
import { GradoDependencia } from "../model/gradodependencia";
import { Slider } from "../model/slider";
import { Queson } from "../model/queson";
import { CardTramite } from "../model/cardtramite";
import { NotificaResumen } from "../model/notificaresumen";
import { NotificaDetalles } from "../model/notificadetalles";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class ServicioGeneral {
  API_URL: string = environment.API_URL;

  //API_URL = 'http://localhost:7090';
  //API_URL = 'https://oficinavirtual.simplegob.com/portal';


  constructor(
    private http: HttpClient,
    private tokenservice: TokenStorageService
  ) {}

  /*
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
*/

  generatePdf(id){
    return this.http.get(`${this.API_URL}/tramite_emvs/generatePdf/${id}`)
  }

  getTipoPersona(): Observable<TipoPersona> {
    return this.http
      .get<TipoPersona>(`${this.API_URL}/tipopersona/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getProvincias(): Observable<Provincia> {
    return this.http
      .get<Provincia>(`${this.API_URL}/provincia/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getComunidades(): Observable<Provincia> {
    return this.http
      .get<Provincia>(`${this.API_URL}/ccaa/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getMunicipios(): Observable<Municipio> {
    return this.http
      .get<Municipio>(`${this.API_URL}/municipio/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getNombreMunicipio(
    provincia: string,
    municipio: string
  ): Observable<Municipio> {
    return this.http
      .get<Municipio>(
        `${this.API_URL}/municipio/get/` + provincia + `/` + municipio
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  getTipoDocumento(): Observable<Documento> {
    return this.http
      .get<Documento>(`${this.API_URL}/tipodocumento/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getTipoVias(): Observable<Via> {
    return this.http
      .get<Via>(`${this.API_URL}/tipovia/list`)
      .pipe(retry(1), catchError(this.handleError));
  }
  getPais(): Observable<Pais> {
    return this.http
      .get<Pais>(`${this.API_URL}/pais/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getFaq(): Observable<FAQ> {
    return this.http
      .get<FAQ>(`${this.API_URL}/faq/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getRolUsuario(): Observable<RolUsuario> {
    let headers = new HttpHeaders({
      Authorization: `Basic ${this.tokenservice.getUser()}`,
    });

    return this.http
      .get<RolUsuario>(`${this.API_URL}/user/${this.tokenservice.getId()}/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getUserList(): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/user/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getUserId(id: number): Observable<any> {
    const url = `${this.API_URL}/user/get/${id}`;
    return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  getMenuLateralList(): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/menu/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getMenuPadreHijo(id: number): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/menu/getChildren/${id}`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getMenuParent(): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/menu/getParentList`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getParents(): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/menu/getParent`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getEstadoCivil(): Observable<EstadoCivil> {
    return this.http
      .get<EstadoCivil>(`${this.API_URL}/estado_civil/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getGradoDiscapacidad(): Observable<GradoDiscapacidad> {
    return this.http
      .get<GradoDiscapacidad>(`${this.API_URL}/grado_discapacidad/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getGradoDependencia(): Observable<GradoDependencia> {
    return this.http
      .get<GradoDependencia>(`${this.API_URL}/grado_dependencia/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  tieneRol(id: number): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/user/usuario/${id}/roles`)
      .pipe(retry(1), catchError(this.handleError));
  }

  exportarCSV(identificador: string, id: number): Observable<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/pdf",
      responseType: "blob",
      Accept: "application/pdf",
      observe: "response",
    }).set("identificador", identificador);

    let API_URL = `${this.API_URL}/exportar/csv/${id}`;
    return this.http.get(API_URL, { headers: headers, responseType: "blob" });
  }

  forgotPasswordData(data: UsuarioRecuperar): Observable<any> {
    let API_URL = `${this.API_URL}/recovery/recover`;
    return this.http.post(API_URL, data);
  }

  forgotPassword(email: string): Observable<any> {
    let API_URL = `${this.API_URL}/recovery/recover`;
    return this.http.post(`${API_URL}`, { email });
  }

  resetPassword(
    identificador: string,
    email: string,
    newPassword: string
  ): Observable<any> {
    return this.http.post(
      `${this.API_URL}/recovery/recovering`,
      { identificador, email, newPassword },
      httpOptions
    );
  }

  getSlider(): Observable<Slider[]> {
    return this.http
      .get<Slider[]>(`${this.API_URL}/slider/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getQueson(): Observable<Queson[]> {
    return this.http
      .get<Queson[]>(`${this.API_URL}/queson/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  //Servicios Card Tramite
  getCardTramite(): Observable<CardTramite[]> {
    return this.http
      .get<CardTramite[]>(`${this.API_URL}/card_tramite/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  cardTramiteDoAction(data) {
    return this.http.post(`${this.API_URL}/card_tramite/doAction`,data );
  }


  getListTipoTramite(): Observable<any> {
    return this.http
      .get<any[]>(`${this.API_URL}/notifica/listTipoEnvio`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getLogsPage(
    cargaTotal: boolean,
    fechaInicio: any,
    fechaFin: any,
    ip: string,
    mensaje: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('cargaTotal', cargaTotal.toString())
      .set('ip', ip == undefined ? '' : ip)
      .set('mensaje', mensaje == undefined ? '' : mensaje);

    if (fechaInicio && fechaFin) {
      params = params.set('fechaInicio', formatDate(fechaInicio, 'yyyy-MM-dd', 'es-ES'));
      params = params.set('fechaFin', formatDate(fechaFin, 'yyyy-MM-dd', 'es-ES'));
    }

    return this.http.get<any>(
      `${this.API_URL}/logs/paginate`,
      { params }
    );
  }

  getNotificacionesPage(
    cargaTotal: boolean,
    fechaInicio: any,
    fechaFin: any,
    nif: string,
    nombreProc: string,
    tipoEnvio: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('cargaTotal', cargaTotal.toString())
      .set('nif', nif == undefined ? '' : nif)
      .set('tipoEnvio', tipoEnvio == undefined ? '' : tipoEnvio)
      .set('nombreProc', nombreProc == undefined ? '' : nombreProc);

    if (fechaInicio && fechaFin) {
      params = params.set('fechaInicio', formatDate(fechaInicio, 'yyyy-MM-dd', 'es-ES'));
      params = params.set('fechaFin', formatDate(fechaFin, 'yyyy-MM-dd', 'es-ES'));
    }

    return this.http.get<any>(
      `${this.API_URL}/notifica/paginate`,
      { params }
    );
  }


//Servicios de Notifica
/*   postNotificaNotificaciones(peticion: any): Observable<NotificaResumen> {
    return this.http.post<NotificaResumen>(
      `${this.API_URL}/notifica/getNotificaciones`,
      peticion
    );
  }

  postNotificaJustificante(justificante): Observable<any> {
    //pendiente de modelar
    return this.http.post<any>(
      `${this.API_URL}/notifica/saveJustificante`,
      justificante
    );
  }

  generateCSVNotificacion(justificante){
    return  this.http.post<any>(
      `${this.API_URL}/notifica/generateCSV`,
      justificante
    );
  }

  getNotificaNotificaciones(id): Observable<NotificaDetalles> {
    return this.http.get<NotificaDetalles>(
      `${this.API_URL}/notifica/getNotificacion/${id}`
    );
  }

  findNotificacion(id): Observable<NotificaDetalles> {
    return this.http.get<NotificaDetalles>(
      `${this.API_URL}/notifica/findNotificacion/${id}`
    );
  }


  signNotificacionClave(data): Observable<NotificaDetalles> {
    return this.http.post<NotificaDetalles>(
      `${this.API_URL}/notifica/signNotificacionClave`,data
    );
  }


  getNotificaReject(id): Observable<any> {
    return this.http.get<any>(
      `${this.API_URL}/notifica/denyNotificacion/${id}`
    );
  }

  getNotificaSinLeer() {
    return this.http.get<any>(
      `${this.API_URL}/notifica/getNotificacionesNoLeidas`
    )
  }

  leerNotificacion(id) {
    return this.http.get<any>(
      `${this.API_URL}/notifica/readNotificacion/${id}`
    )
  } */

  // Error handling
  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
/*   getCaducidades(){
    return     this.http.get<any>(`${this.API_URL}/notifica/getCaducidades`);
  }
  getCaducidadesObs(): void {
    if(!localStorage.getItem('tramiteMaxDays')){
      this.getCaducidades().subscribe(value => {
        if (value) {
          localStorage.setItem('tramiteMaxDays', value.tramiteMaxDays);
          localStorage.setItem('notificacionesPendientesMaxDays', value.notificacionesPendientesMaxDays);
          localStorage.setItem('notificacionesAceptadasMaxDays', value.notificacionesAceptadasMaxDays);
          localStorage.setItem('comunicacionesMaxDays', value.comunicacionesMaxDays);
        }
      })
    }
  } */
  getDepartamentos(){
    return     this.http.get<any>(`${this.API_URL}/departamento/list`);
  }
}
